var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"data39"},[_c('div',{staticClass:"data39Til"},[_vm._v(_vm._s(_vm.list.data.menuTitle))]),_c('div',{staticClass:"data39Cen"},[_vm._v(_vm._s(_vm.list.data.desc))]),_c('div',{staticClass:"data39Img",style:({
			width:("calc(100% - " + _vm.bj + "px)")
		})},[_c('img',{attrs:{"src":_vm.list.data.cover}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }